import React from "react";
import { BsHouse, BsHouseFill, BsTelephoneFill } from "react-icons/bs";
import { HiMail } from "react-icons/hi";
import { RiMessage2Fill } from "react-icons/ri";
import { Link } from "react-router-dom";
import CommingSoonPopUp from "./CommingSoonPopUp";
import useWindowDimensions from "../Hooks/useWindowDimensions";

export default function Sidebar({ isOpen, onClose }) {
  const { width } = useWindowDimensions();
  const isMobile = width <= 768;
  
  return (
    <>
      {isMobile && isOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={onClose}
        />
      )}
      <div className={`sidebar w-28 h-full px-1 ${isMobile && isOpen ? 'mobile-open' : ''} ${isMobile ? 'z-50' : ''}`}>
        <ul className="relative">
          <li className="relative mt-14">
            <Link
              to={"/"}
              className="w-16 h-16 mx-auto flex rounded-xl items-center justify-center"
            >
              <BsHouseFill className="w-10 h-10 text-black mx-auto" />
            </Link>
          </li>
          <li className="relative mt-4">
            <Link
              to={"call"}
              className="w-16 h-16 mx-auto flex rounded-xl items-center justify-center"
            >
              <BsTelephoneFill className="w-9 h-9 text-black mx-auto" />
            </Link>
          </li>
          <li className="relative mt-4">
            <CommingSoonPopUp placement={"right"}>
              <Link
                to={"#"}
                className="w-16 h-16 mx-auto flex rounded-xl items-center justify-center "
              >
                <HiMail className="w-10 h-10 text-black mx-auto" />
              </Link>
            </CommingSoonPopUp>
          </li>

          <li className="relative mt-4">
            <CommingSoonPopUp placement={"right"}>
              <Link
                to={"#"}
                className="w-16 h-16 mx-auto flex rounded-xl items-center justify-center"
              >
                <RiMessage2Fill className="w-10 h-10 text-black mx-auto" />
              </Link>
            </CommingSoonPopUp>
          </li>
        </ul>
      </div>
    </>
  );
}
